import React, { useCallback, useEffect, useState } from "react";
import chatSocketConnection from "../sockets/chat.socket";
import { generateToken, getDataFromStorage } from "../libs/auth.helper";
import EventEmitter from "../utils/EventEmitter";
import useConfig from "../hooks/use-config";
import { getUserInfo } from "../utils/chat.utils";
import AppConfig from "../app-config";
const SocketContext = React.createContext({
    socket: null,
    initialChat: () => {
        return new Promise(() => {
        });
    },
    loadChats: (type) => {
        return new Promise(() => {
        });
    },
    isConnectionFailed: false,
});
let chatSocket = null;
export const generateRoomId = (postId, ownerId, userId) => `${postId}-${ownerId}-${userId}`;
export const SocketContextProvider = (props) => {
    const [socket, setSocket] = useState(null);
    const [isConnectionFailed, setIsConnectionFailed] = useState(false);
    const config = useConfig();
    console.log('socket', socket);
    useEffect(() => {
        if (socket)
            return;
        chatSocket = null;
        initialChat();
        return () => {
            chatSocket === null || chatSocket === void 0 ? void 0 : chatSocket.off('connect');
            chatSocket === null || chatSocket === void 0 ? void 0 : chatSocket.off('disconnect');
            chatSocket === null || chatSocket === void 0 ? void 0 : chatSocket.off('error');
            socket === null || socket === void 0 ? void 0 : socket.io.disconnect();
            socket === null || socket === void 0 ? void 0 : socket.disconnect();
        };
    }, [socket]);
    const fireAuthentication = () => new Promise((resolve) => generateToken().then((token) => {
        var _a;
        console.log(token, 'token and  eq = ', chatSocket.connected);
        const authData = {
            id: parseInt(((_a = getDataFromStorage().userInfo.id) === null || _a === void 0 ? void 0 : _a.toString()) || ''),
            token: token,
            platform: getDataFromStorage().audience,
            country: getDataFromStorage().country,
            lang: AppConfig.getConfig().lang,
            name: getUserInfo().full_name,
            avatar: getUserInfo().profile_picture,
        };
        chatSocket.emit('authentication', authData, function (...data) {
            console.log(data, 'res');
            resolve(true);
            setIsConnectionFailed(false);
        });
    }));
    const initialChat = () => {
        chatSocket = chatSocketConnection(config.urls.chat);
        chatSocket.on('reconnect', function () {
            // setSocket(null)
            // fireAuthentication().then(() => {
            //     console.log('reconnect auth')
            //     setSocket(chatSocket)
            // })
        });
        chatSocket.on("connect", function () {
            console.log('connect');
            setSocket(null);
            fireAuthentication().then(() => {
                console.log('connect auth');
                setSocket(chatSocket);
            });
        });
        chatSocket.on("connect_timeout", function () {
            console.log('connect_timeout');
        });
        chatSocket.on("reconnect_attempt", function () {
            console.log('reconnect_attempt');
        });
        chatSocket.on("reconnect_error", function () {
            console.log('reconnect_error');
        });
        chatSocket.on("reconnect_failed", function () {
            console.log('reconnect_failed');
        });
        chatSocket.on("removeListener", function () {
            console.log('removeListener');
        });
        chatSocket.on("connect_error", function () {
            console.log('connect_error');
            if (socket)
                setSocket(null);
        });
        chatSocket.on('disconnect', function (err) {
            setSocket(null);
            console.error('disconnect');
        });
        chatSocket.on('error', function (err) {
            setSocket(null);
            setIsConnectionFailed(true);
        });
        chatSocket.on("connect_error", (error) => {
            setSocket(null);
            setIsConnectionFailed(true);
        });
    };
    useEffect(() => {
        if (!socket)
            return;
        socket === null || socket === void 0 ? void 0 : socket.on('message', (pid, oid, uid, message, setUpChat) => {
            EventEmitter.emit("message", {
                pid,
                uid,
                message,
                setUpChat
            });
        });
        socket.on("typing", (postId, ownerPostId, userId) => {
            const roomId = generateRoomId(postId, ownerPostId, userId);
            EventEmitter.emit("typing", roomId);
        });
        return () => {
            socket === null || socket === void 0 ? void 0 : socket.off('message');
            socket === null || socket === void 0 ? void 0 : socket.off('typing');
        };
    }, [socket]);
    const loadChats = useCallback((type) => {
        if (!socket)
            return;
        socket === null || socket === void 0 ? void 0 : socket.emit('history-flat-rooms', {
            type: type,
            limit: 1000
        }, function (data) {
            EventEmitter.emit('history-rooms', data);
        });
    }, [socket]);
    return (React.createElement(SocketContext.Provider, { value: {
            socket,
            initialChat,
            loadChats,
            isConnectionFailed
        } }, props.children));
};
export default SocketContext;
